import { MouseEvent, useContext, useRef } from "react";
import { Button } from "iuvity-ui-components/dist/button";
import { Divider } from "iuvity-ui-components/dist/divider";
import { OverlayPanel } from "iuvity-ui-components/dist/overlaypanel";
import { useMediaQuery } from "iuvity-ui-components/dist/hooks";
import { LANGUAGE_OPTIONS } from "../../../constants";
import { AppContext } from "../../../context/index";
import styles from "../login.module.scss";

const LoginMenuLanguage = () => {
  const overlayRef = useRef<any>();
  const isTablet = useMediaQuery("(max-width: 480px)");
  const {
    t,
    appState: { language },
    setAppState,
  } = useContext(AppContext);

  const handleLanguageButton = (e: MouseEvent<HTMLButtonElement>) => {
    overlayRef.current.toggle(e);
  };

  const changeLanguage = (language: string) => {
    setAppState((prev) => ({
      ...prev,
      language,
    }));
    window.IBPeventCreator("CHANGE::LANGUAGE", language);
  };

  return (
    <>
      <Button
        name="language-button"
        variant="p-button-text"
        icon="iu iu-icon-world2"
        label={!isTablet ? language.toUpperCase() : ""}
        onClick={handleLanguageButton}
      />
      <OverlayPanel ref={overlayRef} className={styles.containerLanguage}>
        <p className={styles.tituloOverlay}>{t("Languages.changeLanguage")}</p>
        <Divider />
        <div className={styles.containerLanguageLabels}>
          {LANGUAGE_OPTIONS(t)
            .filter((lan) => lan.value !== language)
            .map((lan) => (
              <p
                key={lan.value}
                className={styles.bodyOverlay}
                onClick={() => changeLanguage(lan.value)}
              >
                {lan.label}
              </p>
            ))}
        </div>
      </OverlayPanel>
    </>
  );
};

export default LoginMenuLanguage;
